import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';

const REFETCH_PROCESSED_FILES = 15_000;

export const getDocumentsOption = () => {
  return queryOptions({
    ...Chat.listRagDocuments({}),
    refetchInterval: (query) => {
      const { data } = query.state;

      const isAllDocumentProcessed =
        data?.findIndex((d) => d.status === 'pending') === -1;

      if (isAllDocumentProcessed) {
        return false;
      }

      return REFETCH_PROCESSED_FILES;
    },
  });
};

export type LoadDocumentVariables = Chat.DocumentUploadRequestType & {
  targetFolderId?: string;
};

export const useLoadDocumentMutation = () => {
  return useMutation({
    mutationFn: ({
      targetFolderId: _targetFolderId,
      ...data
    }: LoadDocumentVariables) =>
      Chat.loadNewRagDocument({
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  });
};

export const useDeleteDocumentMutation = () => {
  const queryClient = useQueryClient();
  const { queryKey: getDocumentQueryKey } = Chat.listRagDocuments({});

  return useMutation({
    mutationFn: (documentId: string) =>
      Chat.deleteRagDocument({ urlParams: { documentId } }),
    onMutate: async (fileId) => {
      const previousDocs: Chat.RagDocumentType[] | undefined =
        queryClient.getQueryData(getDocumentQueryKey);
      queryClient.setQueryData(
        getDocumentQueryKey,
        (old?: Chat.RagDocumentType[]) =>
          old?.filter((f) => f.fileId !== fileId),
      );

      return { previousDocs };
    },
  });
};
